import './style.css';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
);

const Graph = ({ dataset, visibleMetrics, showLegend = true }) => {
    const processMetricData = (metricData) => {
        if (!metricData || Object.keys(metricData).length === 0) return { labels: [], datasets: [] };
        const timestamps = [...new Set(Object.values(metricData).flatMap(entry => entry.data.map(d => d.timestamp)))];
        const datasets = Object.entries(metricData).map(([metricName, values], index) => ({
            label: metricName,
            data: timestamps.map(ts => {
                const match = values.data.find(entry => entry.timestamp === ts);
                return match ? match.value : null; // Default to null if no value found
            }),
            borderColor: values.color,
            backgroundColor: values.color,
            tension: 0.1,
            yAxisID: 'y1',
            hidden: !visibleMetrics.includes(metricName),
        }));
        return { labels: timestamps, datasets };
    };

    // // Example metric data structure:
    // const exampleMetricData = {
    //     "Metric A": [
    //         { timestamp: "3/10", value: 0.001 },
    //         { timestamp: "3/11", value: 0.2 },
    //         { timestamp: "3/12", value: 0.001 },
    //         { timestamp: "3/13", value: 0.003 },
    //         { timestamp: "3/14", value: 0.005 }
    //     ],
    //     "Metric B": [
    //         { timestamp: "3/10", value: 0.005 },
    //         { timestamp: "3/11", value: 0.15 },
    //         { timestamp: "3/12", value: 0.002 },
    //         { timestamp: "3/13", value: 0.006 },
    //         { timestamp: "3/14", value: 0.009 }
    //     ]
    // };
    const data = processMetricData(dataset);
    const options = {
        responsive: true,
        maintainAspectRatio: true,
        aspectRatio: 3,
        scales: {
            x: {
                grid: {
                    display: false,
                }
            },
            y1: {
                type: 'linear',
                position: 'left',
                beginAtZero: false,
                title: {
                    display: true,
                    text: 'Percent (%)',
                }
            }
        },
        plugins: {
            legend: {
                display: showLegend,
                position: 'top',
                labels: {
                    usePointStyle: true,
                    pointStyle: 'circle',
                }
            },
        },
        animation: {
            duration: 500,
            easing: 'easeInOutQuad',
        },
    };

    return (
        <div className='graph-block'>
            <div className='graph'>
                <Line data={data} options={options} />
            </div>
        </div>
    );
};

export { Graph };
